import React, { Fragment } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { faPlus, faEdit } from "@fortawesome/fontawesome-free-solid";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import WithToggle from "./WithToggle";
import CustomerForm from "./CustomerForm";
import {
  compose,
  withHandlers,
  setDisplayName,
  defaultProps,
  lifecycle
} from "recompose";
import { connect } from "react-redux";
import { actions } from "../modules/customers";
import { isFunction } from "lodash";
import Card from "./Card";
import Button from "./CustomButton";

const mapStateToProps = state => ({
  loadingSubmitCustomer: state.customers.loadingSubmitCustomer,
  failureSubmitCustomer: state.customers.failureSubmitCustomer,
  successSubmitCustomer: state.customers.successSubmitCustomer,
  currentCustomer: state.customers.currentCustomer,
  currentDealer: state.dealers.currentDealer,
  filter: state.customers.filter
});

const mapDispatchToProps = {
  createCustomer: actions.createCustomer,
  updateCustomer: actions.updateCustomer,
  setCurrentCustomer: actions.setCurrentCustomer,
  resetState: actions.resetState.bind(null, ["currentCustomer"])
};

const withHandleSubmit = withHandlers({
  onSubmit: ({
    createCustomer,
    updateCustomer,
    currentDealer,
    currentCustomer,
    actionType,
    toggle,
    setCurrentCustomer,
    onCreate
  }) => data => {
    const customerData = {
      user_attributes: data
    };
    const handleSubmitSuccess = customer => {
      toggle();
      setCurrentCustomer(customer);
      isFunction(onCreate) && onCreate();
    };
    if (currentCustomer && actionType === "update") {
      updateCustomer({
        customer_id: currentCustomer.id,
        dealer_id: currentDealer.id,
        data: customerData
      }).then(handleSubmitSuccess);
    } else {
      createCustomer({ data: customerData, dealer_id: currentDealer.id }).then(
        handleSubmitSuccess
      );
    }
  }
});

const enhanced = compose(
  setDisplayName("CustomerButton"),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  WithToggle,
  withHandleSubmit,
  lifecycle({
    componentWillUnmount() {
      this.props.resetState();
    }
  }),
  defaultProps({
    actionType: "create"
  })
);

const initialValues = ({ actionType, currentCustomer, filter }) => {
  if (actionType === "update" && currentCustomer) {
    return currentCustomer;
  } else {
    return {
      first_name: "",
      last_name: "",
      email: "",
      phone_number: "",
      ...(filter || {})
    };
  }
};

const CustomerButton = enhanced(
  ({
    filter,
    children,
    toggledOn,
    toggle,
    show,
    loadingSubmitCustomer,
    failureSubmitCustomer,
    onSubmit,
    actionType,
    currentCustomer,
    resetState
  }) => {
    let action = actionType === "create" ? "Add" : "Update";
    let icon = actionType === "create" ? faPlus : faEdit;
    return (
      <Fragment>
        <Modal isOpen={toggledOn} toggle={toggle} onExit={resetState}>
          <Card
            plain
            content={
              <div>
                <ModalHeader toggle={toggle}>
                  <h3 className="title">
                    {action} Customer <FontAwesomeIcon icon={icon} />
                  </h3>
                </ModalHeader>
                <ModalBody>
                  <CustomerForm
                    currentCustomer={
                      currentCustomer && actionType === "update"
                        ? currentCustomer
                        : null
                    }
                    submitting={loadingSubmitCustomer}
                    failMessage={failureSubmitCustomer}
                    onSubmit={onSubmit}
                    initialValues={initialValues({
                      actionType,
                      currentCustomer,
                      filter
                    })}
                  />
                </ModalBody>
              </div>
            }
          />
        </Modal>
        {typeof children === "function" && children({ show })}
        <Button block onClick={toggle} color="primary" fill>
          {`${action} Customer`} <FontAwesomeIcon icon={icon} />
        </Button>
      </Fragment>
    );
  }
);

export default CustomerButton;
